export const animateDuration = 2;
